import _ from 'lodash'
import queryString from 'query-string'

import routeParams from 'helpers/routeParams'

const GET_TASKS_REGISTRATION = 'dofe-bo/assessorTasks/GET_TASKS_REGISTRATION'
const GET_TASKS_REGISTRATION_SUCCESS = 'dofe-bo/assessorTasks/GET_TASKS_REGISTRATION_SUCCESS'
const GET_TASKS_REGISTRATION_FAIL = 'dofe-bo/assessorTasks/GET_TASKS_REGISTRATION_FAIL'

const ASSESSOR_REG_APPROVE = 'dofe-bo/assessor/ASSESSOR_REG_APPROVE'
const ASSESSOR_REG_APPROVE_SUCCESS = 'dofe-bo/assessor/ASSESSOR_REG_APPROVE_SUCCESS'
const ASSESSOR_REG_APPROVE_FAIL = 'dofe-bo/assessor/ASSESSOR_REG_APPROVE_FAIL'

const GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION = 'dofe-bo/assessorTasks/GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION'
const GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION_SUCCESS = 'dofe-bo/assessorTasks/GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION_SUCCESS'
const GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION_FAIL = 'dofe-bo/assessorTasks/GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION_FAIL'

const ACTIVITY_CATEGORY_REGISTRATION_APPROVE = 'dofe-bo/assessor/ACTIVITY_CATEGORY_REGISTRATION_APPROVE'
const ACTIVITY_CATEGORY_REGISTRATION_APPROVE_SUCCESS = 'dofe-bo/assessor/ACTIVITY_CATEGORY_REGISTRATION_APPROVE_SUCCESS'
const ACTIVITY_CATEGORY_REGISTRATION_APPROVE_FAIL = 'dofe-bo/assessor/ACTIVITY_CATEGORY_REGISTRATION_APPROVE_FAIL'

const DELETE_ASSESSOR_REGISTRATION = 'dofe-bo/ASSESSORS/DELETE_ASSESSOR_REGISTRATION'
const DELETE_ASSESSOR_REGISTRATION_SUCCESS = 'dofe-bo/ASSESSORS/DELETE_ASSESSOR_REGISTRATION_SUCCESS'
const DELETE_ASSESSOR_REGISTRATION_FAIL = 'dofe-bo/ASSESSORS/DELETE_ASSESSOR_REGISTRATION_FAIL'

const UPDATE_ASSESSOR_REGISTRATION = 'dofe-bo/ASSESSORS/UPDATE_ASSESSOR_REGISTRATION'
const UPDATE_ASSESSOR_REGISTRATION_SUCCESS = 'dofe-bo/ASSESSORS/UPDATE_ASSESSOR_REGISTRATION_SUCCESS'
const UPDATE_ASSESSOR_REGISTRATION_FAIL = 'dofe-bo/ASSESSORS/UPDATE_ASSESSOR_REGISTRATION_FAIL'

const UPDATE_ACTIVITY_REGISTRATION = 'dofe-bo/ASSESSORS/UPDATE_ACTIVITY_REGISTRATION'
const UPDATE_ACTIVITY_REGISTRATION_SUCCESS = 'dofe-bo/ASSESSORS/UPDATE_ACTIVITY_REGISTRATION_SUCCESS'
const UPDATE_ACTIVITY_REGISTRATION_FAIL = 'dofe-bo/ASSESSORS/UPDATE_ACTIVITY_REGISTRATION_FAIL'

const DELETE_ACTIVITY_REGISTRATION = 'dofe-bo/ASSESSORS/DELETE_ACTIVITY_REGISTRATION'
const DELETE_ACTIVITY_REGISTRATION_SUCCESS = 'dofe-bo/ASSESSORS/DELETE_ACTIVITY_REGISTRATION_SUCCESS'
const DELETE_ACTIVITY_REGISTRATION_FAIL = 'dofe-bo/ASSESSORS/DELETE_ACTIVITY_REGISTRATION_FAIL'

const SET_PARAMS = 'dofe-bo/assessor/SET_PARAMS'

const initialState = {
  list: [],
  detail: {},
  activityCategoryRegistration: {
    list: [],
    sort: '',
    offset: 0,
    limit: 20,
    pages: 1,
    count: null,
    filter: '',
    invalidate: null,
    loading: false,
    loaded: false
  },
  sort: '',
  offset: 0,
  limit: 20,
  pages: 1,
  count: null,
  filter: '',
  invalidate: null,
  loading: false,
  loaded: false
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_TASKS_REGISTRATION:
      return {
        ...state,
        loading: true
      }
    case GET_TASKS_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result || [],
        count: action.headers['x-total-count'],
        pages:
          Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
      }
    case GET_TASKS_REGISTRATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION:
      return {
        ...state,
        activityCategoryRegistration: {
          ...state.activityCategoryRegistration,
          loading: true
        }
      }
    case GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION_SUCCESS:
      return {
        ...state,
        activityCategoryRegistration: {
          ...state.activityCategoryRegistration,
          loading: false,
          loaded: true,
          list: action.result || [],
          count: action.headers['x-total-count'],
          pages:
              Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
              state.pages
        }

      }
    case GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION_FAIL:
      return {
        ...state,
        activityCategoryRegistration: {
          ...state.activityCategoryRegistration,
          loading: false,
          loaded: false,
        },
        error: action.error
      }
    case SET_PARAMS:
      return {
        ...state,
        limit:
          action.options.limit !== undefined
            ? action.options.limit
            : state.limit,
        offset:
          action.options.offset !== undefined
            ? action.options.offset
            : state.offset,
        filter:
          action.options.filter !== undefined
            ? action.options.filter
            : state.filter,
        sort:
          action.options.sort !== undefined
            ? action.options.sort
            : state.sort,
        invalidate: _.isEmpty(action.options)
          ? state.invalidate
          : new Date().getTime()
      }
    case DELETE_ASSESSOR_REGISTRATION:
      return {
        ...state,
        loading: true
      }
    case DELETE_ASSESSOR_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        detail: action.result
      }
    case DELETE_ASSESSOR_REGISTRATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case UPDATE_ASSESSOR_REGISTRATION:
        return {
            ...state,
            loading: true
        }
    case UPDATE_ASSESSOR_REGISTRATION_SUCCESS:
        return {
            ...state,
            loading: false
        }
    case UPDATE_ASSESSOR_REGISTRATION_FAIL:
        return {
            ...state,
            loading: false,
            error: action.error
        }
    case UPDATE_ACTIVITY_REGISTRATION:
        return {
            ...state,
            loading: true
        }
    case UPDATE_ACTIVITY_REGISTRATION_SUCCESS:
        return {
            ...state,
            loading: false
        }
    case UPDATE_ACTIVITY_REGISTRATION_FAIL:
        return {
            ...state,
            loading: false,
            error: action.error
        }
    case DELETE_ACTIVITY_REGISTRATION:
      return {
        ...state,
        loading: true
      }
    case DELETE_ACTIVITY_REGISTRATION_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case DELETE_ACTIVITY_REGISTRATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default:
      return state
  }
}

export const getTasksAssessors = (params, baseFilter) => {
  return {
    types: [
      GET_TASKS_REGISTRATION,
      GET_TASKS_REGISTRATION_SUCCESS,
      GET_TASKS_REGISTRATION_FAIL
    ],
    promise: client =>
      client.get(
        `api/tasks/assessor-registration-approval?with=ACTIVITY_CATEGORY_REGISTRATION,ASSESSOR${routeParams(
          params,
          baseFilter
        )}`
      )
  }
}

export const approveAssessorRegistration = (id, data) => ({
  types: [
    ASSESSOR_REG_APPROVE,
    ASSESSOR_REG_APPROVE_SUCCESS,
    ASSESSOR_REG_APPROVE_FAIL
  ],
  promise: client =>
    client.post(`api/assessor-registration-approval/${id}`, { data })
})

export const getAssessorActivityCategoryRegistrationApprovalTasks = (params, baseFilter) => {
  return {
    types: [
      GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION,
      GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION_SUCCESS,
      GET_TASKS_ACTIVITY_CATEGORY_REGISTRATION_FAIL
    ],
    promise: client =>
        client.get(
            `api/tasks/assessor-activity-category-registration-approval?with=REGISTER,REGISTRATION,ASSESSOR,ASSESSOR_WWC,ASSESSOR_FILES,ACTIVITY_CATEGORY${routeParams(
                params,
                baseFilter
            )}`
        )
  }
}

export const approveActivityCategoryRegistration = (id, data) => ({
  types: [
    ACTIVITY_CATEGORY_REGISTRATION_APPROVE,
    ACTIVITY_CATEGORY_REGISTRATION_APPROVE_SUCCESS,
    ACTIVITY_CATEGORY_REGISTRATION_APPROVE_FAIL
  ],
  promise: client =>
      client.post(`api/assessor-activity-category-registration-approval/${id}`, { data })
})

export function setAssessorTasksParams(options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function deleteAssessorRegistration(id, data) {
  return {
    types: [DELETE_ASSESSOR_REGISTRATION, DELETE_ASSESSOR_REGISTRATION_SUCCESS, DELETE_ASSESSOR_REGISTRATION_FAIL],
    promise: client =>
        client.del(`api/assessor-registrations/${id}?${queryString.stringify(data)}`, {})
  }
}

export function updateAssessorRegistration(id, data) {
  return {
      types: [UPDATE_ASSESSOR_REGISTRATION, UPDATE_ASSESSOR_REGISTRATION_SUCCESS, UPDATE_ASSESSOR_REGISTRATION_FAIL],
      promise: client =>
          client.post(`api/assessor-registrations/${id}/update`, { data })
  }
}

export function updateActivityRegistration(id, data) {
  return {
      types: [UPDATE_ACTIVITY_REGISTRATION, UPDATE_ACTIVITY_REGISTRATION_SUCCESS, UPDATE_ACTIVITY_REGISTRATION_FAIL],
      promise: client =>
          client.post(`api/assessor-activity-category-registrations/${id}/update`, { data })
  }
}

export function deleteActivityRegistration(id, data) {
  return {
    types: [DELETE_ACTIVITY_REGISTRATION, DELETE_ACTIVITY_REGISTRATION_SUCCESS, DELETE_ACTIVITY_REGISTRATION_FAIL],
    promise: client =>
        client.del(`api/assessor-activity-category-registrations/${id}?${queryString.stringify(data)}`)
  }
}